import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../app/providers/auth-provider";
import { LoginForm } from "../components/login-form";
import { RegisterForm } from "../components/register-form";

export function LoginPage() {
  const [isRegistering, setIsRegistering] = useState(false);
  const navigate = useNavigate();
  const { refreshSession } = useAuth();

  const handleSuccess = async () => {
    await refreshSession();
    navigate("/", { replace: true });
  };

  const heading = isRegistering ? "Create an account" : "";
  const subheading = isRegistering
    ? "Please enter your details to sign up."
    : "";

  return (
    <div className="min-h-screen bg-surface flex items-center justify-center overflow-x-hidden p-md">
      <div className="w-full max-w-[400px] bg-surface-container-lowest border border-outline-variant rounded-lg p-xl shadow-sm">
        <div className="flex flex-col items-center mb-xl">
          {heading && (
            <h1 className="font-h2 text-primary font-bold">{heading}</h1>
          )}
          {subheading && (
            <p className="font-body-md text-secondary mt-1">{subheading}</p>
          )}
        </div>

        {isRegistering ? (
          <RegisterForm
            onSuccess={handleSuccess}
            onSwitchToLogin={() => setIsRegistering(false)}
          />
        ) : (
          <>
            <LoginForm onSuccess={handleSuccess} />
            <div className="mt-md text-center">
              <button
                type="button"
                className="font-body-md text-secondary hover:text-primary transition-colors underline-offset-2 hover:underline"
                onClick={() => setIsRegistering(true)}
              >
                Create an account →
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
